"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateVIN = exports.validateChassisNumber = void 0;
const validateChassisNumber = (value) => {
    const chassisRegex = /^[A-HJ-NPR-Z0-9]{15,20}$/; // Valid alphanumerics excluding I, O, Q
    if (!chassisRegex.test(value)) {
        return "Invalid Chassis Number";
    }
    return true; // If valid, return true
};
exports.validateChassisNumber = validateChassisNumber;
const validateVIN = (value) => {
    // Regex to exclude I, O, Q and check for VIN's valid structure
    const vinRegex = /^[A-HJ-NPR-Z0-9]{8}$/;
    if (!vinRegex.test(value)) {
        return "Invalid VIN format";
    }
    return true; // Validation passed
};
exports.validateVIN = validateVIN;
